import React, { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client';
import { useLocation, useHistory, Link } from 'react-router-dom';
import { getMyUserQuery } from '../../queries/queries';
import MainNavigation from './MainNavigation';
import Role from './Role';
import { Possession } from '../../types/types';
import User from '../../img/user.svg';
import Logout from '../../img/logout.svg';
import { IoIosMenu } from 'react-icons/io';


const { REACT_APP_BRAND } = process.env;

interface NavigationProps {
  logout: () => void;
  possessionLS?: Possession;
  setPossessionLS: (possession: Possession) => void;
  firstURLParam?: string;
  secondURLParam?: string;
  fourthURLParam?: string;
  fifthURLParam?: string;
  sixthURLParam?: string;
  seventhURLParam?: string;
  eighthURLParam?: string;
}

const Navigation = (props: NavigationProps) => {
  const { logout, possessionLS, setPossessionLS, firstURLParam, secondURLParam, fourthURLParam, fifthURLParam, sixthURLParam, seventhURLParam, eighthURLParam } = props;
  const [possession, setPossession] = useState(possessionLS);
  const [redirecting, setRedirecting] = useState(false);
  const [changing, setChanging] = useState(false);

  const { data: userQuery, loading: userLoading, error: userError } = useQuery(getMyUserQuery);

  const location = useLocation();
  const history = useHistory();


  function setPoss(p, r = true, c = false) {
    setPossessionLS(p);
    if (possession !== p) setPossession(p);
    if (redirecting !== r) setRedirecting(r);
    if (changing !== c) setChanging(c);
  }

  const userQueryReady = userQuery && !userLoading && !userError && userQuery.user;

  const { zonesIAdmin, bookletsIAdmin, companiesIAdmin, associationsIAdmin, teamsIAdmin, teamMembersIAdmin } =
    (userQueryReady ?
      userQuery.user?.adminObjects :
      {
        zonesIAdmin: [],
        bookletsIAdmin: [],
        companiesIAdmin: [],
        associationsIAdmin: [],
        teamsIAdmin: [],
        teamMembersIAdmin: []
      }
    );

  const numberOfPossesions = userQueryReady && (zonesIAdmin.length + companiesIAdmin.length + associationsIAdmin.length + teamsIAdmin.length + teamMembersIAdmin.length + (userQuery.user?.superAdmin && 1));
  const buyerPossession = { title1: userQueryReady ? `${userQuery.user?.firstname} ${userQuery.user?.lastname}` : '', typeTitle: 'Köpare', type: 'buyer' };
  const invitationGuardianPossession = { title1: 'Lagmedlem', typeTitle: 'Inbjudan', type: 'invitation' };
  const invitationTeamLeaderPossession = { title1: 'Lag', typeTitle: 'Inbjudan', type: 'invitation' };
  const invitationAssociationPossession = { title1: 'Förening', typeTiyle: 'Inbjudan', type: 'invitation' }

  useEffect(() => {
    const onBuyPage = firstURLParam === 'kop' || firstURLParam === 'order';
    const onInvitationPage = firstURLParam === 'invitation';
    const onRootPage = !firstURLParam || firstURLParam === 'login';
    const onTeamPage = firstURLParam === 'cities' && secondURLParam === 'associations' && fourthURLParam === 'teams' && sixthURLParam && !seventhURLParam;
    const onTeamMemberPage = firstURLParam === 'cities' && secondURLParam === 'associations' && fourthURLParam === 'teams' && sixthURLParam?.toLowerCase() === 'teammembers' && !!seventhURLParam;


    if (onRootPage) {
      localStorage.removeItem('LOCK_USER');
    }

    if (onInvitationPage && !redirecting) {
      if (!possession || possession.type !== 'invitation') {
        if (secondURLParam === 'team') {
          setPoss(invitationTeamLeaderPossession, false);
        }
        else if (secondURLParam === 'teammemberguardian') {
          setPoss(invitationGuardianPossession, false);
        }
        else {
          setPoss(invitationAssociationPossession, false)
        }
      }
    }
    else if (numberOfPossesions) { // Is "admin"
      if (!possession && onBuyPage) { // Entered URL /kop
        setPoss(buyerPossession, false);
      }
      else if (!possession && onTeamPage) {
        teamsIAdmin.map((team) => {
          if (team._id === fifthURLParam) {
            setPoss(formatedPossession('team', team), false);
          }
          return;
        });
      }
      else if (!possession && onTeamMemberPage) {
        teamMembersIAdmin.map((teamMember) => {
          if (teamMember._id === seventhURLParam) {
            setPoss(formatedPossession('teamMember', teamMember), false);
          }
          return;
        });
      }
      else if (!possession && numberOfPossesions === 1) { // Only one admin-possession available
        let poss = buyerPossession;
        if (userQuery.user?.superAdmin) {
          poss = formatedPossession('superAdmin', {});
        }
        else if (zonesIAdmin.length) {
          poss = formatedPossession('zone', zonesIAdmin[0]);
        }
        else if (bookletsIAdmin.length) {
          poss = formatedPossession('booklet', bookletsIAdmin[0]);
        }
        else if (companiesIAdmin.length) {
          poss = formatedPossession('company', companiesIAdmin[0]);
        }
        else if (associationsIAdmin.length) {
          poss = formatedPossession('association', associationsIAdmin[0]);
        }
        else if (teamsIAdmin.length) {
          poss = formatedPossession('team', teamsIAdmin[0]);
        }
        else if (teamMembersIAdmin.length) {
          poss = formatedPossession('teamMember', teamMembersIAdmin[0]);
        }
        setPoss(poss, true);
      }
      else if (possession && onRootPage && !redirecting) { // Just logged in and possession saved from previous session?
        setPoss(null, false);
      }
    }
    else { // Not "admin"
      if (!possession || possession.type !== 'buyer') { // Possession not 'buyer'
        setPoss(buyerPossession, !onBuyPage);
      }
      else if (possession && onRootPage && !redirecting) { // Logged in, not admin, possession allready set, redirect not triggered yet
        setRedirecting(true);
      }
    }

  }, [location.pathname])

  useEffect(() => {
    const teamFromApp = firstURLParam === 'cities' && secondURLParam === 'associations' && fourthURLParam === 'teams' && !!fifthURLParam && sixthURLParam?.toLowerCase() === 'teammembers' && !seventhURLParam;
    const teammemberFromApp = firstURLParam === 'cities' && secondURLParam === 'associations' && fourthURLParam === 'teams' && sixthURLParam === 'teamMembers' && !!seventhURLParam && !eighthURLParam;

    if (teammemberFromApp) {
      history.push(`${location.pathname}/home`);
    }
    if (teamFromApp) {
      history.push(location.pathname.split('/').slice(0, -1).join('/') + '/home')
    }
  }, [])

  if (userLoading) {
    return null;
  }
  if (userError) {
    setPoss(null, false);
    logout();
    return null;
  }

  function formatedPossession(adminObjectType: string, obj: any) {
    return {
      superAdmin:
        { title1: `${userQuery.user?.firstname} ${userQuery.user?.lastname}`, typeTitle: 'Superadmin', type: 'superAdmin' },
      zone:
        { _id: obj._id, title1: obj.name, typeTitle: 'Zon', type: 'zone' },
      company:
        { _id: obj._id, zoneId: obj.zoneId, title1: obj.name, title2: obj.zoneName, typeTitle: 'Företag', type: 'company' },
      association:
        { _id: obj._id, zoneId: obj.zoneId, title1: obj.name, title2: obj.zoneName, typeTitle: 'Förening', type: 'association' },
      team:
        { _id: obj._id, associationId: obj.associationId, title1: obj.name, title2: obj.associationName, typeTitle: 'Lag', type: 'team' },
      teamMember:
        { _id: obj._id, associationId: obj.associationId, teamId: obj.teamId, title1: `${obj.firstname} ${obj.lastname}`, title2: `${obj.associationName}, ${obj.teamName}`, typeTitle: 'Lagmedlem', type: 'teamMember' },
      buyer:
        { title1: `${userQuery.user?.firstname} ${userQuery.user?.lastname}`, typeTitle: 'Köpare', type: 'buyer' }
    }[adminObjectType] as Possession;
  }

  return (
    <nav className={`main-nav ${REACT_APP_BRAND === 'SAENKELT' ? 'saenkelt' : ''}`}>
      <MainNavigation possession={possession} redirect={redirecting} />
      <div className="nav-user">
        <button className={`menu-icon`} onClick={() => setChanging(true)}>
          <IoIosMenu size={36} color='#333' />
        </button>
      </div>
      {(possession && possession.type && !changing) ? null :
        (
          <div className="modal" onClick={() => { setChanging(false); }}>
            <div className="box md">
              <h3>
                Du är inloggad som
              </h3>
              <p>{userQuery.user?.email}</p>
              <div className="nav-table">
                <table>
                  <tbody>
                    {(numberOfPossesions > 0) && <tr><td className="small-label">Du hanterar följande konton:</td></tr>}
                    {userQuery.user?.superAdmin
                      && <Role key="superAdmin" possession={formatedPossession('superAdmin', {})} onClick={setPoss} />}

                    {zonesIAdmin && zonesIAdmin.map((obj) => (
                      <Role key={obj._id} possession={formatedPossession('zone', obj)} onClick={setPoss} />
                    ))}
                    {companiesIAdmin && companiesIAdmin.map((obj) => (
                      <Role key={obj._id} possession={formatedPossession('company', obj)} onClick={setPoss} />
                    ))}
                    {associationsIAdmin && associationsIAdmin.map((obj) => (
                      <Role key={obj._id} possession={formatedPossession('association', obj)} onClick={setPoss} />
                    ))}
                    {teamsIAdmin && teamsIAdmin.map((obj) => (
                      <Role key={obj._id} possession={formatedPossession('team', obj)} onClick={setPoss} />
                    ))}
                    {teamMembersIAdmin && teamMembersIAdmin.map((obj) => (
                      <Role key={obj._id} possession={formatedPossession('teamMember', obj)} onClick={setPoss} />
                    ))}
                  </tbody>
                </table>
              </div>

              {possession && changing && (
                <button type="button" className="x md" onClick={() => { setChanging(false); }}>Avbryt</button>)}
              {
                !localStorage.getItem('LOCK_USER') &&
                <div className="user-actions">
                  <Link to="/profile" className="primary text" onClick={() => { if (!possession) alert('Vänligen välj en roll innan du går in på inställningar för din användare.') }}><img className="user" src={User} />Mina uppgifter</Link>
                  <Link to="/" className="primary text" onClick={() => { setPoss(null, false); logout(); }}><img className="logout" src={Logout} alt="logout" />Logga ut</Link>
                </div>
              }
            </div>
          </div>
        )}
    </nav>
  );
}

export default Navigation
